import { jsx, jsxs } from 'react/jsx-runtime';
import { EGDSIconSize, EGDSIcon } from '../../icons/icon/index.esm.js';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-button-toggle.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
var EGDSButtonToggleLabelOptions;
(function (EGDSButtonToggleLabelOptions) {
  EGDSButtonToggleLabelOptions[EGDSButtonToggleLabelOptions["ICON_FIRST"] = 1] = "ICON_FIRST";
  EGDSButtonToggleLabelOptions[EGDSButtonToggleLabelOptions["TEXT_FIRST"] = 2] = "TEXT_FIRST";
})(EGDSButtonToggleLabelOptions || (EGDSButtonToggleLabelOptions = {}));
const EGDSButtonToggle = props => {
  const {
    altText,
    checked = false,
    className,
    disabled = false,
    icon,
    iconSize = EGDSIconSize.MEDIUM,
    id,
    name,
    onChange,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Applied to avoid a breaking change. Must be fixed ASAP with https://github.expedia.biz/egds/uitk-react/issues/6520
    label,
    labelText,
    stacked = false,
    subLabelText,
    ...attributes
  } = props;
  const baseClass = 'uitk-button-toggle';
  const wrapperClassName = getClassNameList(baseClass, className, {
    [`${baseClass}-is-checked`]: checked,
    [`${baseClass}-is-disabled`]: disabled
  }, stacked ? `${baseClass}-is-stacked` : `${baseClass}-is-inline`);
  const contentClassName = getClassNameList(`${baseClass}-content`);
  const labelTextClassName = getClassNameList(`${baseClass}-label-text`);
  const inputClassName = getClassNameList(`${baseClass}-input`, `is-visually-hidden`);
  const subLabelTextClassName = getClassNameList(`${baseClass}-label-subtext`);
  const iconClassName = getClassNameList(`${baseClass}-icon`);
  let a11ylabel = '';
  if (labelText) {
    a11ylabel = `${labelText}. ${subLabelText || ''}`;
  } else {
    a11ylabel = `${subLabelText || ''}`;
  }
  return jsx("div", {
    className: wrapperClassName,
    children: jsxs("label", {
      className: contentClassName,
      htmlFor: id,
      children: [jsx("input", {
        "aria-label": altText || a11ylabel.trim(),
        id: id,
        name: name,
        type: "checkbox",
        onChange: onChange,
        className: inputClassName,
        disabled: disabled,
        checked: checked,
        "aria-checked": checked,
        value: checked ? 'true' : 'false',
        ...attributes
      }), icon && jsx(EGDSIcon, {
        className: iconClassName,
        name: icon,
        size: iconSize
      }), labelText && jsx("span", {
        className: labelTextClassName,
        "aria-hidden": "true",
        children: labelText
      }), stacked && subLabelText && jsx("span", {
        className: subLabelTextClassName,
        "aria-hidden": "true",
        children: subLabelText
      })]
    })
  });
};
EGDSButtonToggle.displayName = 'EGDSButtonToggle';
export { EGDSButtonToggle, EGDSButtonToggleLabelOptions };